import React, { useState, useEffect } from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { Tooltip } from '@mui/material';
// import InfoIcon from '@mui/icons-material/Info';

const VersionDisplay = ({ 
  showIcon = true, 
  showDate = false, 
  variant = "caption", 
  color = "text.secondary",
  position = "bottom-right" // bottom-right, top-right, bottom-left, top-left
}) => {
  const [versionInfo, setVersionInfo] = useState(null);
  const theme = useTheme();
  // En mobile la barra inferior es fija: el cartel se corre para no taparla.
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    // Intentar cargar la información de versión
    try {
      const versionData = require('../version.json');
      setVersionInfo(versionData);
    } catch (error) {
      // Si no existe el archivo, usar la versión del package.json
      setVersionInfo({
        version: process.env.REACT_APP_VERSION || '0.1.0',
        buildDate: new Date().toISOString(),
        buildNumber: 0
      });
    }
  }, []);

  if (!versionInfo) return null;

  const getPositionStyles = () => {
    const bottomOffset = isMobile
      ? 'calc(68px + env(safe-area-inset-bottom) + 4px)'
      : '0px';

    const baseStyles = {
      position: 'fixed',
      zIndex: 900,
      pointerEvents: 'none',
      opacity: 0.9,
      padding: '4px 8px',
      backgroundColor: 'var(--sup-surface)',
      color: 'var(--sup-ink-3)',
      borderRadius: '6px',
      backdropFilter: 'blur(4px)',
      border: '1px solid var(--sup-border)'
    };

    switch (position) {
      case 'bottom-right':
        return { ...baseStyles, bottom: bottomOffset, right: '0px' };
      case 'top-right':
        return { ...baseStyles, top: '0px', right: '0px' };
      case 'bottom-left':
        return { ...baseStyles, bottom: bottomOffset, left: '0px' };
      case 'top-left':
        return { ...baseStyles, top: '0px', left: '0px' };
      default:
        return { ...baseStyles, bottom: bottomOffset, right: '0px' };
    }
  };

  const versionText = showDate 
    ? `v${versionInfo.version} (${new Date(versionInfo.buildDate).toLocaleDateString()})`
    : `v${versionInfo.version}`;

  return (
    <Box sx={getPositionStyles()}>
      {/* <Tooltip 
        title={
          <div>
            <div>Versión: {versionInfo.version}</div>
            <div>Build: {versionInfo.buildNumber}</div>
            <div>Fecha: {new Date(versionInfo.buildDate).toLocaleString()}</div>
          </div>
        }
        arrow
      > */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {/* {showIcon && <InfoIcon sx={{ fontSize: 14, color }} />} */}
          <Typography 
            variant={variant}
            sx={{ fontSize: '0.72rem', fontWeight: 500, color: 'var(--sup-ink-3)' }}
          >
            {versionText}
          </Typography>
        </Box>
      {/* </Tooltip> */}
    </Box>
  );
};

export default VersionDisplay; 